module.exports = __webpack_public_path__ + "b29b42b99cecce46991ce54393a8d997.png";